'use client';

import { useEffect } from 'react';

export function StickyInteraction() {
  useEffect(() => {
    const blockBanner = document.getElementById(
      'sticky-banner',
    ) as HTMLDivElement;

    const stickyBanner = document.getElementById(
      'sticky-banner-fixed',
    ) as HTMLDivElement;

    const connectMe = document.getElementById(
      'connect-me-component',
    ) as HTMLDivElement;

    const blockBannerContainer = document.getElementById(
      'sticky-banner-container',
    ) as HTMLDivElement;

    const stickyBannerContainer = document.getElementById(
      'sticky-banner-fixed-container',
    ) as HTMLDivElement;

    // Create an IntersectionObserver to detect when the element intersects with the viewport
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.intersectionRatio === 0) {
          stickyBanner.classList.remove('hidden');
          if (connectMe) {
            stickyBannerContainer.appendChild(connectMe);
          }
        } else {
          stickyBanner.classList.add('hidden');
          if (connectMe) {
            blockBannerContainer.appendChild(connectMe);
          }
        }
      },
      { threshold: [0], root: null },
    );

    // Observe the sticky element
    observer.observe(blockBanner);

    return () => {
      observer.disconnect();
    };
  }, []);

  return null;
}
